import type { RouteRecordRaw } from 'vue-router'
import { Layout } from '@/utils/routerHelper'

const ticketRoutes: RouteRecordRaw[] = [
  {
    path: '/ticket',
    name: 'Ticket',
    component: Layout,
    meta: {
      title: '门票管理',
      icon: 'vi-ep:ticket',
      alwaysShow: true
    },
    children: [
      {
        path: 'issue',
        component: () => import('@/views/Ticket/IssueList.vue'),
        name: 'TicketIssueList',
        meta: { title: '门票模板' }
      },
      {
        path: 'list',
        component: () => import('@/views/Ticket/TicketList.vue'),
        name: 'TicketList',
        meta: { title: '门票列表' }
      },
      {
        path: 'reward',
        component: () => import('@/views/Ticket/RewardList.vue'),
        name: 'TicketRewardList',
        meta: { title: '发放记录' }
      }
    ]
  }
]

export default ticketRoutes
